import { Inject, Pipe, PipeTransform } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { routes } from '../../../../utils/routes';

@Pipe({
  name: 'routeTranslate',
  standalone: true,
  pure: false,
})
export class RouteTranslatePipe implements PipeTransform {
  constructor(@Inject(I18NEXT_SERVICE) private translateService: ITranslationService) {}

  transform(value: any, relative?: boolean): any {
    if (relative) return `${routes[this.translateService.language as 'it']['routes.' + value]}`;
    else
      return `/${this.translateService.language}/${routes[this.translateService.language as 'it']['routes.' + value]}`;
  }
}
